(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-basket"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kawaii-voucher-host')) {
  customElements.define('kawaii-voucher-host', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.addEventListener('click', async (event) => {
        const opener = event.target.closest('[data-voucher-open]');
        if (opener && this.contains(opener)) {
          const dialog = document.getElementById(opener.dataset.voucherOpen);
          if (dialog && !dialog.open) { this.opener = opener; dialog.showModal(); }
          return;
        }
        const dialog = event.target.closest('.kv-dialog');
        if (!dialog) return;
        if (event.target.closest('[data-voucher-close]')) { dialog.close(); return; }
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          return;
        }
        const copy = event.target.closest('[data-voucher-copy]');
        if (!copy) return;
        const input = dialog.querySelector('.kv-code');
        const status = dialog.querySelector('.kv-status');
        try {
          await navigator.clipboard.writeText(input.value);
          if (this.isConnected) status.textContent = copy.dataset.copied;
        } catch {
          input.focus(); input.select(); input.setSelectionRange(0, input.value.length);
          status.textContent = 'Select and copy the code above.';
        }
      }, { signal });
      this.querySelectorAll('.kv-dialog').forEach(dialog => {
        dialog.addEventListener('close', () => { this.opener?.focus(); }, { signal });
      });
      this.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-voucher-form]');
        if (!form) return;
        event.preventDefault();
        if (form.dataset.busy === 'true') return;
        const dialog = form.closest('.kv-dialog');
        const button = form.querySelector('[type="submit"]');
        const status = dialog.querySelector('.kv-status');
        const label = button.textContent;
        form.dataset.busy = 'true'; button.disabled = true; button.textContent = 'Adding…';
        form.setAttribute('aria-busy', 'true'); status.textContent = '';
        let added = false;
        try {
          const root = form.dataset.root;
          const response = await fetch(root + 'cart/add.js', {
            method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body:JSON.stringify({ items:[{ id:new FormData(form).get('id'), quantity:1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this item. Please try again.');
          added = true;
          if (!this.isConnected) return;
          status.textContent = 'Added! Opening your basket…';
          const destination = form.dataset.apply === 'true' && form.dataset.code
            ? root + 'discount/' + encodeURIComponent(form.dataset.code) + '?redirect=' + encodeURIComponent(form.dataset.cart)
            : form.dataset.cart;
          window.location.assign(destination);
        } catch (error) {
          if (!this.isConnected) return;
          status.textContent = added ? 'Item added. Please open your basket to continue.' : (error instanceof TypeError ? 'Connection problem. Check your basket before trying again.' : error.message);
        } finally {
          if (this.isConnected) {
            form.removeAttribute('aria-busy');
            if (!added) { form.dataset.busy = 'false'; button.disabled = false; button.textContent = label; }
          }
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.querySelectorAll('.kv-dialog[open]').forEach(dialog => dialog.close());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
